import { render, staticRenderFns } from "./Splitscreen.vue?vue&type=template&id=1e8e54b7&scoped=true&"
import script from "./Splitscreen.vue?vue&type=script&lang=js&"
export * from "./Splitscreen.vue?vue&type=script&lang=js&"
import style0 from "./Splitscreen.vue?vue&type=style&index=0&id=1e8e54b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e54b7",
  null
  
)

export default component.exports